import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { usePreferences } from '../hooks/usePreferences';
import { MANY_EMAILS, NOT_INTERESTED, OTHER } from '../utils/variables';

import FormRow from './FormRow';
import FormFieldText from './FormFieldText';
import FormFieldRadioButton from './FormFieldRadioButton';
import Loader from './Loader';

export default function PreferencesStep1() {
  const {
    tellUsMore,
    reasonForUnsubscribe,
    isLoading,
    handleChangeRadioButton,
    handleChangeTextField,
    back,
    save
  } = usePreferences();

  const buttons = [
    {
      onClick: back,
      version: 'tertiary-text',
      label: <Trans id="buttonLabelBackToEmailPreferences" />
    },

    {
      onClick: save,
      version: 'primary',
      label: isLoading ? (
        <Loader isLoading={isLoading} />
      ) : (
        <Trans id="buttonLabelNext" />
      )
    }
  ];
  return (
    <form
      noValidate
      className="form --white-background-color --with-border"
      data-module="form"
    >
      <FormRow
        title={<Trans id="preferencesFeedbackTitle" />}
        description={<Trans id="preferencesFeedbackDescription" />}
      />
      <FormRow title={<Trans id="preferencesUnsubscribeReasonTitle" />}>
        <FormFieldRadioButton
          formName="reasonForOptOut"
          name={MANY_EMAILS}
          value={reasonForUnsubscribe === MANY_EMAILS}
          onChange={() => handleChangeRadioButton(MANY_EMAILS)}
          label={<Trans id="preferencesReasonForUnsubscribeTooManyEmails" />}
        />
        <FormFieldRadioButton
          formName="reasonForOptOut"
          name={NOT_INTERESTED}
          value={reasonForUnsubscribe === NOT_INTERESTED}
          onChange={() => handleChangeRadioButton(NOT_INTERESTED)}
          label={<Trans id="preferencesReasonForUnsubscribeNotInterested" />}
        />
        <FormFieldRadioButton
          formName="reasonForOptOut"
          name={OTHER}
          value={reasonForUnsubscribe === OTHER}
          onChange={() => handleChangeRadioButton(OTHER)}
          label={<Trans id="preferencesReasonForUnsubscribeOther" />}
        />
        {reasonForUnsubscribe === OTHER && (
          <FormFieldText
            onChange={(e) => handleChangeTextField(e.target.value)}
            value={tellUsMore}
            name="tellUsMore"
            label="placeholderReasonForUnsubscribeDetails"
            isValid={tellUsMore}
            required={false}
          />
        )}
      </FormRow>
      <FormRow buttons={buttons} />
    </form>
  );
}
